import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFinanceSummaryQuery } from "generated/generated-models";
import { Loading } from "../lib/components/Loading";
import { FinanceBalancesView } from "./FinanceBalancesView";
const FinanceSummaryBalances = () => {
    const { data, loading, error } = useFinanceSummaryQuery();
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsxs("div", { children: ["Error!: ", error.message] });
    }
    if (!data) {
        return FinanceBalancesView({});
    }
    const financeSummary = data.financeSummary || undefined;
    return FinanceBalancesView({
        financeSummary,
    });
};
export { FinanceSummaryBalances };
